import { coachRecommends } from '@abroad/components'

export const sowRefId = 'coaching'

export const CONSTANTS = {
  LEADER_360_METADATA: {
    leader: {
      headerText: `Please send this Leader Assessment request to at least 3 direct reports.`,
      description: `You may view your results after 3 responses have been logged. Additional requests may be sent until your results have been made available.`,
      emailMessage: `Dear [Firstname],<br/><br/>[User's Name] is participating in a leadership development program and has requested your valuable insights for their Leader Assessment. Your feedback will contribute to a comprehensive analysis that aids in enhancing their leadership effectiveness and supporting team synergy.<br/><br/>All responses will be shared anonymously in aggregate form alongside all other responses and will not be attributed to you, so please be as honest as possible.<br/><br/>Your perspective is instrumental. By dedicating a few minutes to share your observations, you’re directly contributing to the enrichment and evolution of leadership dynamics within your team.<br/><br/><span class="text-saffron-700 font-bold-700">Take Leader Assessment</span><br/><br/>Thank you for your time and feedback,<br/>[User's Name]`,
    },
    simple360: {
      headerText: `Please send this feedback request to at least 3 people who you want to partake in your simple 360.`,
      description: `Only your coach will be able to see the responses. Once a request has been fulfilled, a green checkmark will appear next to their email.`,
      emailMessage: `Dear [Firstname],<br/><br/>As part of my Abroad coaching program, my coach and I are requesting your feedback on my most important areas for personal and professional development. Your feedback will be sent directly to my coach, not me, so feel free to be honest and candid. Your input will play a crucial role in shaping my growth plan.<br/><br/>My coach will then review your response and integrate your feedback into my overall growth plan. All responses will be shared anonymously and will not be attributed to you.<br/><br/>Here’s the question we’d like you to answer:<br/><br/><b>If I experienced 2-3 breakthroughs in my personal and professional development over the next six months, what would you want that to be? In other words, what are the most important areas for my personal and professional development?</b><br/><br/>Your support means a lot to me, and I truly appreciate your time and insights!<br/><br/><span class="text-saffron-700 font-bold-700">Provide Your Feedback Here</span><br/><br/>Thank you for your time and feedback,<br/>[User's Name]`,
    },
  },
}
// export const participantLevelForManager = [
//   'manager',
//   'leader',
//   'executive',
//   'ceo',
// ]

export const messages = {
  noJourneysFound: `No ${coachRecommends.toLowerCase()} found.`,
  upgradeErrorMsg:
    'You need to upgrade your plan to take advantage of these features.',
}

export const mediaModuleTypeObject = {
  MODULE: 'module',
  MODULE_MEDIA: 'module-media',
  MEDIA_LIBRARY_AUDIO: 'media-library-audio',
}

export const leader360Type = {
  LEADER: 'leader',
  SIMPLE360: 'simple360',
}

export const surveyType = {
  AWARENESS: 'awareness',
  LEADER: 'leader',
  WISDOM: 'wisdom',
  PROSPERITY: 'prosperity',
}
export const workStatus = {
  OPERATING: 'operating',
  TRANSITION: 'transition',
}

export const selfAwarenessMediaUrl =
  'https://abroad-public.s3.us-east-2.amazonaws.com/01+Self+Awareness.mp3'

export const teamCohesionMediaUrl =
  'https://abroad-public.s3.us-east-2.amazonaws.com/02+Team+Cohesion.mp3'

export const visionImpactMediaUrl =
  'https://abroad-public.s3.us-east-2.amazonaws.com/03+Vision+%26+Impact.mp3'

export const managerEfficacyMediaUrl =
  'https://abroad-public.s3.us-east-2.amazonaws.com/04+Manager+Efficacy.mp3'

export const selfAwarenessPerceptionMediaUrl =
  'https://abroad-public.s3.us-east-2.amazonaws.com/05+Self+Awareness+Perception.mp3'

export const inTransitionSelfAwarenessMediaUrl =
  'https://abroad-public.s3.us-east-2.amazonaws.com/06+Self+Awareness+(Leaders+in+Transition).mp3'

export const nameRegex = /^[A-Za-z\s-]+$/

// Country code constants for country question type
export const COUNTRY_CODES = [
  { code: 'us', name: 'United States', dialCode: '1' },
  { code: 'ru', name: 'Russia', dialCode: '7' },
  { code: 'eg', name: 'Egypt', dialCode: '20' },
  { code: 'za', name: 'South Africa', dialCode: '27' },
  { code: 'gr', name: 'Greece', dialCode: '30' },
  { code: 'nl', name: 'Netherlands', dialCode: '31' },
  { code: 'be', name: 'Belgium', dialCode: '32' },
  { code: 'fr', name: 'France', dialCode: '33' },
  { code: 'es', name: 'Spain', dialCode: '34' },
  { code: 'hu', name: 'Hungary', dialCode: '36' },
  { code: 'it', name: 'Italy', dialCode: '39' },
  { code: 'ro', name: 'Romania', dialCode: '40' },
  { code: 'ch', name: 'Switzerland', dialCode: '41' },
  { code: 'at', name: 'Austria', dialCode: '43' },
  { code: 'gb', name: 'United Kingdom', dialCode: '44' },
  { code: 'dk', name: 'Denmark', dialCode: '45' },
  { code: 'se', name: 'Sweden', dialCode: '46' },
  { code: 'no', name: 'Norway', dialCode: '47' },
  { code: 'pl', name: 'Poland', dialCode: '48' },
  { code: 'de', name: 'Germany', dialCode: '49' },
  { code: 'pe', name: 'Peru', dialCode: '51' },
  { code: 'mx', name: 'Mexico', dialCode: '52' },
  { code: 'cu', name: 'Cuba', dialCode: '53' },
  { code: 'ar', name: 'Argentina', dialCode: '54' },
  { code: 'br', name: 'Brazil', dialCode: '55' },
  { code: 'cl', name: 'Chile', dialCode: '56' },
  { code: 'co', name: 'Colombia', dialCode: '57' },
  { code: 've', name: 'Venezuela', dialCode: '58' },
  { code: 'my', name: 'Malaysia', dialCode: '60' },
  { code: 'au', name: 'Australia', dialCode: '61' },
  { code: 'id', name: 'Indonesia', dialCode: '62' },
  { code: 'ph', name: 'Philippines', dialCode: '63' },
  { code: 'nz', name: 'New Zealand', dialCode: '64' },
  { code: 'th', name: 'Thailand', dialCode: '66' },
  { code: 'jp', name: 'Japan', dialCode: '81' },
  { code: 'kr', name: 'South Korea', dialCode: '82' },
  { code: 'vn', name: 'Vietnam', dialCode: '84' },
  { code: 'bd', name: 'Bangladesh', dialCode: '880' },
  { code: 'in', name: 'India', dialCode: '91' },
  { code: 'pk', name: 'Pakistan', dialCode: '92' },
  { code: 'af', name: 'Afghanistan', dialCode: '93' },
  { code: 'lk', name: 'Sri Lanka', dialCode: '94' },
  { code: 'mm', name: 'Myanmar', dialCode: '95' },
  { code: 'ir', name: 'Iran', dialCode: '98' },
  { code: 'ss', name: 'South Sudan', dialCode: '211' },
  { code: 'so', name: 'Somalia', dialCode: '252' },
  { code: 'dz', name: 'Algeria', dialCode: '213' },
  { code: 'ad', name: 'Andorra', dialCode: '376' },
  { code: 'ao', name: 'Angola', dialCode: '244' },
  { code: 'ai', name: 'Anguilla', dialCode: '1264' },
  { code: 'ag', name: 'Antigua and Barbuda', dialCode: '1268' },
  { code: 'am', name: 'Armenia', dialCode: '374' },
  { code: 'aw', name: 'Aruba', dialCode: '297' },
  { code: 'az', name: 'Azerbaijan', dialCode: '994' },
  { code: 'bs', name: 'Bahamas', dialCode: '1242' },
  { code: 'bh', name: 'Bahrain', dialCode: '973' },
  { code: 'bb', name: 'Barbados', dialCode: '1246' },
  { code: 'by', name: 'Belarus', dialCode: '375' },
  { code: 'bz', name: 'Belize', dialCode: '501' },
  { code: 'bj', name: 'Benin', dialCode: '229' },
  { code: 'bt', name: 'Bhutan', dialCode: '975' },
  { code: 'bo', name: 'Bolivia', dialCode: '591' },
  { code: 'ba', name: 'Bosnia and Herzegovina', dialCode: '387' },
  { code: 'bw', name: 'Botswana', dialCode: '267' },
  { code: 'bn', name: 'Brunei', dialCode: '673' },
  { code: 'bg', name: 'Bulgaria', dialCode: '359' },
  { code: 'bf', name: 'Burkina Faso', dialCode: '226' },
  { code: 'bi', name: 'Burundi', dialCode: '257' },
  { code: 'kh', name: 'Cambodia', dialCode: '855' },
  { code: 'cm', name: 'Cameroon', dialCode: '237' },
  { code: 'ca', name: 'Canada', dialCode: '1' },
  { code: 'cv', name: 'Cape Verde', dialCode: '238' },
  { code: 'cf', name: 'Central African Republic', dialCode: '236' },
  { code: 'td', name: 'Chad', dialCode: '235' },
  { code: 'cn', name: 'China', dialCode: '86' },
  { code: 'km', name: 'Comoros', dialCode: '269' },
  { code: 'cg', name: 'Congo', dialCode: '242' },
  { code: 'cd', name: 'Democratic Republic of the Congo', dialCode: '243' },
  { code: 'cr', name: 'Costa Rica', dialCode: '506' },
  { code: 'ci', name: "Côte d'Ivoire", dialCode: '225' },
  { code: 'hr', name: 'Croatia', dialCode: '385' },
  { code: 'cy', name: 'Cyprus', dialCode: '357' },
  { code: 'cz', name: 'Czech Republic', dialCode: '420' },
  { code: 'dj', name: 'Djibouti', dialCode: '253' },
  { code: 'dm', name: 'Dominica', dialCode: '1767' },
  { code: 'do', name: 'Dominican Republic', dialCode: '1809' },
  { code: 'ec', name: 'Ecuador', dialCode: '593' },
  { code: 'sv', name: 'El Salvador', dialCode: '503' },
  { code: 'gq', name: 'Equatorial Guinea', dialCode: '240' },
  { code: 'er', name: 'Eritrea', dialCode: '291' },
  { code: 'ee', name: 'Estonia', dialCode: '372' },
  { code: 'et', name: 'Ethiopia', dialCode: '251' },
  { code: 'fj', name: 'Fiji', dialCode: '679' },
  { code: 'fi', name: 'Finland', dialCode: '358' },
  { code: 'ga', name: 'Gabon', dialCode: '241' },
  { code: 'gm', name: 'Gambia', dialCode: '220' },
  { code: 'ge', name: 'Georgia', dialCode: '995' },
  { code: 'gh', name: 'Ghana', dialCode: '233' },
  { code: 'gd', name: 'Grenada', dialCode: '1473' },
  { code: 'gt', name: 'Guatemala', dialCode: '502' },
  { code: 'gn', name: 'Guinea', dialCode: '224' },
  { code: 'gw', name: 'Guinea-Bissau', dialCode: '245' },
  { code: 'gy', name: 'Guyana', dialCode: '592' },
  { code: 'ht', name: 'Haiti', dialCode: '509' },
  { code: 'hn', name: 'Honduras', dialCode: '504' },
  { code: 'is', name: 'Iceland', dialCode: '354' },
  { code: 'iq', name: 'Iraq', dialCode: '964' },
  { code: 'ie', name: 'Ireland', dialCode: '353' },
  { code: 'il', name: 'Israel', dialCode: '972' },
  { code: 'jm', name: 'Jamaica', dialCode: '1876' },
  { code: 'jo', name: 'Jordan', dialCode: '962' },
  { code: 'kz', name: 'Kazakhstan', dialCode: '7' },
  { code: 'ke', name: 'Kenya', dialCode: '254' },
  { code: 'ki', name: 'Kiribati', dialCode: '686' },
  { code: 'kp', name: 'North Korea', dialCode: '850' },
  { code: 'kw', name: 'Kuwait', dialCode: '965' },
  { code: 'kg', name: 'Kyrgyzstan', dialCode: '996' },
  { code: 'la', name: 'Laos', dialCode: '856' },
  { code: 'lv', name: 'Latvia', dialCode: '371' },
  { code: 'lb', name: 'Lebanon', dialCode: '961' },
  { code: 'ls', name: 'Lesotho', dialCode: '266' },
  { code: 'lr', name: 'Liberia', dialCode: '231' },
  { code: 'ly', name: 'Libya', dialCode: '218' },
  { code: 'li', name: 'Liechtenstein', dialCode: '423' },
  { code: 'lt', name: 'Lithuania', dialCode: '370' },
  { code: 'lu', name: 'Luxembourg', dialCode: '352' },
  { code: 'mk', name: 'North Macedonia', dialCode: '389' },
  { code: 'mg', name: 'Madagascar', dialCode: '261' },
  { code: 'mw', name: 'Malawi', dialCode: '265' },
  { code: 'mv', name: 'Maldives', dialCode: '960' },
  { code: 'ml', name: 'Mali', dialCode: '223' },
  { code: 'mt', name: 'Malta', dialCode: '356' },
  { code: 'mh', name: 'Marshall Islands', dialCode: '692' },
  { code: 'mr', name: 'Mauritania', dialCode: '222' },
  { code: 'mu', name: 'Mauritius', dialCode: '230' },
  { code: 'fm', name: 'Micronesia', dialCode: '691' },
  { code: 'md', name: 'Moldova', dialCode: '373' },
  { code: 'mc', name: 'Monaco', dialCode: '377' },
  { code: 'mn', name: 'Mongolia', dialCode: '976' },
  { code: 'me', name: 'Montenegro', dialCode: '382' },
  { code: 'ma', name: 'Morocco', dialCode: '212' },
  { code: 'mz', name: 'Mozambique', dialCode: '258' },
  { code: 'na', name: 'Namibia', dialCode: '264' },
  { code: 'nr', name: 'Nauru', dialCode: '674' },
  { code: 'np', name: 'Nepal', dialCode: '971' },
  { code: 'ni', name: 'Nicaragua', dialCode: '505' },
  { code: 'ne', name: 'Niger', dialCode: '227' },
  { code: 'ng', name: 'Nigeria', dialCode: '234' },
  { code: 'om', name: 'Oman', dialCode: '968' },
  { code: 'pw', name: 'Palau', dialCode: '680' },
  { code: 'pa', name: 'Panama', dialCode: '507' },
  { code: 'pg', name: 'Papua New Guinea', dialCode: '675' },
  { code: 'py', name: 'Paraguay', dialCode: '595' },
  { code: 'pt', name: 'Portugal', dialCode: '351' },
  { code: 'qa', name: 'Qatar', dialCode: '974' },
  { code: 'rw', name: 'Rwanda', dialCode: '250' },
  { code: 'kn', name: 'Saint Kitts and Nevis', dialCode: '1869' },
  { code: 'lc', name: 'Saint Lucia', dialCode: '1758' },
  { code: 'vc', name: 'Saint Vincent and the Grenadines', dialCode: '1784' },
  { code: 'ws', name: 'Samoa', dialCode: '685' },
  { code: 'sm', name: 'San Marino', dialCode: '378' },
  { code: 'st', name: 'São Tomé and Príncipe', dialCode: '239' },
  { code: 'sa', name: 'Saudi Arabia', dialCode: '966' },
  { code: 'sn', name: 'Senegal', dialCode: '221' },
  { code: 'rs', name: 'Serbia', dialCode: '381' },
  { code: 'sc', name: 'Seychelles', dialCode: '248' },
  { code: 'sl', name: 'Sierra Leone', dialCode: '232' },
  { code: 'sg', name: 'Singapore', dialCode: '65' },
  { code: 'sk', name: 'Slovakia', dialCode: '421' },
  { code: 'si', name: 'Slovenia', dialCode: '421' },
  { code: 'sb', name: 'Solomon Islands', dialCode: '677' },
  { code: 'sd', name: 'Sudan', dialCode: '249' },
  { code: 'sr', name: 'Suriname', dialCode: '597' },
  { code: 'sz', name: 'Eswatini', dialCode: '268' },
  { code: 'sy', name: 'Syria', dialCode: '963' },
  { code: 'tw', name: 'Taiwan', dialCode: '886' },
  { code: 'tj', name: 'Tajikistan', dialCode: '992' },
  { code: 'tz', name: 'Tanzania', dialCode: '255' },
  { code: 'tl', name: 'Timor-Leste', dialCode: '670' },
  { code: 'tg', name: 'Togo', dialCode: '228' },
  { code: 'to', name: 'Tonga', dialCode: '676' },
  { code: 'tt', name: 'Trinidad and Tobago', dialCode: '1868' },
  { code: 'tn', name: 'Tunisia', dialCode: '216' },
  { code: 'tr', name: 'Turkey', dialCode: '90' },
  { code: 'tm', name: 'Turkmenistan', dialCode: '993' },
  { code: 'tv', name: 'Tuvalu', dialCode: '688' },
  { code: 'ug', name: 'Uganda', dialCode: '256' },
  { code: 'ua', name: 'Ukraine', dialCode: '380' },
  { code: 'ae', name: 'United Arab Emirates', dialCode: '971' },
  { code: 'uy', name: 'Uruguay', dialCode: '598' },
  { code: 'uz', name: 'Uzbekistan', dialCode: '998' },
  { code: 'vu', name: 'Vanuatu', dialCode: '678' },
  { code: 'va', name: 'Vatican City', dialCode: '379' },
  { code: 'ye', name: 'Yemen', dialCode: '967' },
  { code: 'zm', name: 'Zambia', dialCode: '260' },
  { code: 'zw', name: 'Zimbabwe', dialCode: '263' },
]
